import type { AdminAsset } from '@diana/contracts';
import { ImageIcon } from 'lucide-react';
import { useState } from 'react';
import { Link } from 'react-router-dom';

export function MediaCard({ asset, search }: { asset: AdminAsset; search: string }) {
  return (
    <Link
      className="media-library__card"
      to={`/settings/media/${asset.id}${search}`}
      aria-label={`${asset.originalFilename} — ${asset.alt}`}
    >
      <span className="media-library__thumbnail">
        <MediaPreview asset={asset} />
        {asset.usage.draft + asset.usage.releases === 0 ? (
          <span className="media-library__unused">Not used</span>
        ) : null}
        {!asset.alt.trim() ? <span className="media-library__missing">No alt</span> : null}
      </span>
      <span className="media-library__filename">{asset.originalFilename}</span>
      <span className="media-library__status">
        {asset.status === 'Ready' ? 'Uploaded' : asset.status}
        {asset.archivedAt ? ' · Archived' : ''}
      </span>
    </Link>
  );
}

export function MediaPreview({ asset }: { asset: AdminAsset }) {
  const [previewFailed, setPreviewFailed] = useState(false);
  return previewFailed ? (
    <span
      className="media-library__unavailable"
      role="img"
      aria-label={`Preview unavailable: ${asset.alt || asset.originalFilename}`}
    >
      <ImageIcon size={22} aria-hidden="true" />
      <span>Preview unavailable</span>
    </span>
  ) : (
    <img
      src={`/api/v1/admin/assets/${asset.id}/preview`}
      alt={asset.alt}
      loading="lazy"
      onError={() => setPreviewFailed(true)}
    />
  );
}
